import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { IGym } from '@rogue/universal'
import type { IRogue } from '../services/RogueTypes'

export const useGymStore = defineStore('gyms', () => {
  // allGyms and gymDeatils have the same type, but not all of the fields will
  // be populated on the all gyms list to speed up search logic.
  const allGyms = ref<IGym[]>([])
  const gymDetails = ref<{ [gymId: string]: IGym }>({})

  let loadAllPromise: Promise<IGym[]> | null = null

  async function loadAll(rogue: IRogue): Promise<IGym[]> {
    if (loadAllPromise) {
      return loadAllPromise
    }

    loadAllPromise = rogue.fetch<IGym[]>('/svc_gym/gyms').then((gyms: IGym[]) => {
      allGyms.value = gyms

      return gyms
    })

    return loadAllPromise
  }

  async function loadGymDetails(gymId: string, rogue: IRogue): Promise<IGym> {
    if (gymDetails.value[gymId]) {
      return Promise.resolve(gymDetails.value[gymId])
    }

    return rogue.fetch<IGym>(`/svc_gym/gyms/${gymId}`).then((gym: IGym) => {
      // Don't show products that are missing thumbnails
      gym.products = gym.products?.filter(p => !!p.thumbnail)
      gymDetails.value[gymId] = gym

      return gym
    })
  }

  return {
    loadGymDetails,
    loadAll,
  }
})
